import store from '../store';
import Order from '../views/order/Index.vue'
import {checkauth} from "../Helper";
import OrderPrint from "@/views/order/Print.vue";
import PrintReceipt from "@/views/order/PrintReceipt.vue";
import OrderMultiplePrint from "@/views/order/MultiplePrint.vue";

// inserimento, modifica, duplicazione, tracking e riepilogo sono pagine: tornando indietro la lista riparte dal suo URL
const OrderCreate = () => import('../views/order/Create.vue');
const OrderEdit = () => import('../views/order/Edit.vue');
// board ordini in lavorazione: la sfera 3D pesa, si carica solo qui
const OrderBoard = () => import('../views/orderboard/Index.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
    {
        path: '/orders',
        name: 'orders',
        component: Order,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                    // console.log(response)
                    if(response){
                        //console.log("login")
                        next();
                    }else{
                        //console.log("next")
                        next('/login');
                    };
                }

            )
        }
    },
	// fuori da /orders/: il menu evidenzia le voci per prefisso, con /orders/board si accendeva anche "Lista ordini"
	{
		path: '/orders-board',
		name: 'orders-board',
		component: OrderBoard,
		beforeEnter: auth,
	},
	// indirizzo della prima versione, per i link gia' salvati
	{
		path: '/orders/board',
		redirect: '/orders-board',
	},
	{
		path: '/orders/new',
		name: 'order-new',
		component: OrderCreate,
		beforeEnter: auth,
	},
	// :id e' l'_id dell'ordine (24 caratteri esadecimali): "new" non puo' mai finire qui
	{
		path: '/orders/:id([0-9a-fA-F]{24})',
		name: 'order-edit',
		component: OrderEdit,
		props: { mode: 'edit' },
		beforeEnter: auth,
	},
	{
		path: '/orders/:id([0-9a-fA-F]{24})/duplicate',
		name: 'order-duplicate',
		component: OrderEdit,
		props: { mode: 'duplicate' },
		beforeEnter: auth,
	},
	{
		path: '/orders/:id([0-9a-fA-F]{24})/tracking',
		name: 'order-tracking',
		component: OrderEdit,
		props: { mode: 'tracking' },
		beforeEnter: auth,
	},
	{
		path: '/orders/:id([0-9a-fA-F]{24})/summary',
		name: 'order-summary',
		component: OrderEdit,
		props: { mode: 'summary' },
		beforeEnter: auth,
	},
    {
        path: `/orders/print/:id`,
        name: `ordersPrint`,
        component: OrderPrint,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: `/orders/receipt/:id`,
        name: `ordersReceipt`,
        component: PrintReceipt,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
      path: `/orders/multiple-print/:ids`,
      name: `ordersMultiplePrint`,
      component: OrderMultiplePrint,
      beforeEnter (to,from,next){
        checkauth().then( response =>{
            if(response){
              next();
            }else{
              next('/login');
            }
          }

        )
      }
    },


]
